module.exports = "8060bf8f474a07a6d359f664db026853.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/flags/america.png
// module id = 89
// module chunks = 0